import { actionCreator } from '@ardoq/rxbeach';
import {
  APIScopeData,
  BatchRequest,
  BooleanOperator,
  Operator,
  QueryBuilderRuleValue,
} from '@ardoq/api-types';
import { SelectOption } from '@ardoq/select';
import type { QueryBuilderFilterDefinition } from '@ardoq/query-builder';

export const createReferencesForComponentsRequested = actionCreator<string[]>(
  '[createReferences] CREATE_REFERENCES_FOR_COMPONENTS_REQUESTED'
);

export const tripleSelected = actionCreator<string | null>(
  '[createReferences] TRIPLE_SELECTED'
);

export const tripleExpansionToggled = actionCreator<string>(
  '[createReferences] TRIPLE_EXPANSION_TOGGLED'
);

export const filterTermChanged = actionCreator<string>(
  '[createReferences] FILTER_TERM_CHANGED'
);

export const componentTypeFiltersChanged = actionCreator<string[]>(
  '[createReferences] COMPONENT_TYPE_FILTERS_CHANGED'
);

export const referenceTypeFiltersChanged = actionCreator<string[]>(
  '[createReferences] REFERENCE_TYPE_FILTERS_CHANGED'
);

export const tripleFiltersCleared = actionCreator(
  '[createReferences] TRIPLE_FILTERS_CLEARED'
);

export const componentSearchTermChanged = actionCreator<string>(
  '[createReferences] COMPONENT_SEARCH_TERM_CHANGED'
);

export const componentSearchResultsReceived = actionCreator<APIScopeData>(
  '[createReferences] COMPONENT_SEARCH_RESULTS_RECEIVED'
);

export const componentSearchCleared = actionCreator(
  '[createReferences] COMPONENT_SEARCH_CLEARED'
);

export const targetComponentsSelected = actionCreator<APIScopeData>(
  '[createReferences] TARGET_COMPONENTS_SELECTED'
);

export const showAllTriplesToggled = actionCreator(
  '[createReferences] SHOW_ALL_TRIPLES_TOGGLED'
);

export const createNewComponentStarted = actionCreator<string>(
  '[createReferences] CREATE_NEW_COMPONENT_FLOW_STARTED'
);

export const createNewComponentCancelled = actionCreator(
  '[createReferences] CREATE_NEW_COMPONENT_FLOW_CANCELLED'
);

export const newComponentNameChanged = actionCreator<string>(
  '[createReferences] NEW_COMPONENT_NAME_CHANGED'
);

export const workspaceForNewComponentSelected =
  actionCreator<SelectOption<string> | null>(
    '[createReferences] WORKSPACE_FOR_NEW_COMPONENT_SELECTED'
  );

export type CreateReferencesMethod =
  | 'quickConnect'
  | 'newComponent'
  | 'referenceType';

export type SubmitCreateReferencesPayload = {
  batchRequest: BatchRequest;
  newComponentBatchId: string | null;
  capturedFilterTerm: string;
  method: CreateReferencesMethod;
};

export const submitCreateReferencesRequested =
  actionCreator<SubmitCreateReferencesPayload>(
    '[createReferences] SUBMIT_CREATE_REFERENCES_REQUESTED'
  );

export type CreateReferencesAndComponentSucceededPayload = {
  createdComponentId: string | null;
  capturedFilterTerm: string;
};

export const createReferencesAndComponentSucceeded =
  actionCreator<CreateReferencesAndComponentSucceededPayload>(
    '[createReferences] CREATE_REFERENCES_AND_COMPONENT_SUCCEEDED'
  );

export const createReferencesAndComponentFailed = actionCreator(
  '[createReferences] CREATE_REFERENCES_AND_COMPONENT_FAILED'
);

export const searchQueryEditorOpened = actionCreator(
  '[createReferences] SEARCH_QUERY_EDITOR_OPENED'
);

export const searchQueryEditorCancelled = actionCreator(
  '[createReferences] SEARCH_QUERY_EDITOR_CANCELLED'
);

export const searchQueryEditorConfirmed = actionCreator(
  '[createReferences] SEARCH_QUERY_EDITOR_CONFIRMED'
);

export type SearchQueryFilterAddedPayload = {
  rowId: string;
  filterBy: string;
  filterDefinition: QueryBuilderFilterDefinition;
  operator: Operator;
};

export const searchQueryFilterAdded =
  actionCreator<SearchQueryFilterAddedPayload>(
    '[createReferences] SEARCH_QUERY_FILTER_ADDED'
  );

export type SearchQueryFilterUpdatePayload = {
  rowId: string;
  partial: {
    filterBy?: string;
    filterDefinition?: QueryBuilderFilterDefinition;
    operator?: Operator;
    value?: QueryBuilderRuleValue;
  };
};

export const searchQueryFilterUpdated =
  actionCreator<SearchQueryFilterUpdatePayload>(
    '[createReferences] SEARCH_QUERY_FILTER_UPDATED'
  );

export const searchQueryFilterDeleted = actionCreator<string>(
  '[createReferences] SEARCH_QUERY_FILTER_DELETED'
);

export const searchQueryConditionChanged = actionCreator<BooleanOperator>(
  '[createReferences] SEARCH_QUERY_CONDITION_CHANGED'
);
